import React from "react";

import { StyledNameIcon } from "./styled";

export type NameIconProps = {
  name: string;
  color?: string;
};

export const NameIcon: React.FC<NameIconProps> = (props: NameIconProps) => {
  return (
    <>
      <StyledNameIcon color={props.color}>{props.name}</StyledNameIcon>
    </>
  );
};
